<template>
  <div class="common-body" data-animate="preloader-opacity">
    <section
      v-for="item in bodyItems.filter((bodyItem) => !bodyItem.hideSection)"
      :key="item.id"
      :class="{
        'p-top-xxl-1':
          item.__typename !== 'MaskTextRecord' && item.__typename !== 'SectionRecord' && item.__typename !== 'SlimBannerRecord' && item.__typename !== 'CardCarouselRecord' &&
          !(item.__typename === 'ContactBlockRecord' && item.isHighlighted),
        'p-bottom-xxl-1': item.__typename === 'ContactsBlockSlotRecord',
        'height-90':
          item.__typename === 'ImageVideoBlockRecord' ||
          item.__typename === 'FullscreenImageRecord',
      }"
      :style="{
        '--background-color': item.backgroundColor?.hex,
        '--text-color': item.textColor?.hex,
      }"
    >
      <template
        v-if="
          item.__typename === 'TimelineBlockRecord' &&
          item.timelineList?.length
        "
      >
        <PagesCommonTimeline :data="item" />
      </template>
      <template v-if="item.__typename === 'SectionRecord'">
        <PagesCommonSection :data="item" />
      </template>
      <template v-if="item.__typename === 'TextImageBlockRecord'">
        <PagesCommonTextImageBlock :content="item" />
      </template>
      <template v-if="item.__typename === 'SlimBannerRecord'">
        <PagesCommonSlimBanner :data="item" />
      </template>
      <template v-if="item.__typename === 'CenteredMediaBlockRecord'">
        <PagesCommonCenteredImage :data="item" />
      </template>
      <template v-if="item.__typename === 'VideoBlockRecord'">
        <PagesCommonCenteredVideo :data="item" />
      </template>
      <template
        v-if="item.__typename === 'ZoomMasonryRecord' && item.images?.length"
      >
        <WidgetZoomMasonry :images="item.images" />
      </template>
      <template
        v-if="item.__typename === 'CardCarouselRecord' && item.slides?.length"
      >
        <PagesCommonGeneralCarousel :item="item" />
      </template>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PagesCommonBody',
}
</script>

<script setup>
const props = defineProps({
  bodyItems: {
    type: Array,
    default: () => [],
  },
  touch: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
